import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7l6tbl88g3: FaireBrandEntity = {
  token: "b_7l6tbl88g3",
  type: "brand",
  name: "La Luna Bella - Toys",
  avatarUrl:
    "https://cdn.faire.com/fastly/83c8a1866ba59fe89dc83fa992e59c503bdf9aae43af30223b8c5de46650eb71.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/b2f7d18949ccd0f9858787cc4e958111b3d8159e21d79514b452e0891fe6edde.png",
  logoUrl:
    "https://cdn.faire.com/fastly/83c8a1866ba59fe89dc83fa992e59c503bdf9aae43af30223b8c5de46650eb71.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b2f7d18949ccd0f9858787cc4e958111b3d8159e21d79514b452e0891fe6edde.png",
  location: "Las Vegas, NV, USA",
  minimumOrderDollars: 150,
  rating: 4.6,
  reviewCount: 554,
  isTopShop: true,
  isInsider: true,
  description:
    "La Luna Bella provides a one-stop source for the highest quality products, innovative designs, and best pricing.  we are constantly working with our partners who design and develop new and exciting products every season. Our extensive product line consists of thousands of items and is constantly growing. We are well known and respected as the preferred source for traditional novelty toys, games, glow items, inflatables, party supplies, souvenirs and gift items. We always follow the latest trends and styles to create fun and innovative products that you and your customers will love.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:50.722Z",
    importedBy: "entity-db-cli",
  },
};
